export var EField;
(function (EField) {
    EField["Name"] = "name";
    EField["SortWeight"] = "sortWeight";
})(EField || (EField = {}));
